import {StationDashboardRankModel} from '@/types/channel/station/station.model';
import {numberCommaString} from '@/utils/channel';
import React from 'react';

interface RankInfoProp {
  rankInfo?: StationDashboardRankModel[];
}
const ChannelRankInfo = ({rankInfo}: RankInfoProp) => {
  if (!rankInfo) {
    return null;
  }

  return (
    <>
      <dl>
        <dt>순위</dt>
        {rankInfo.map((item, index) => (
          <dd key={index}>
            <strong>{item.rankName}</strong>
            <b>{numberCommaString(item.totalRank)}위</b>
          </dd>
        ))}
      </dl>
    </>
  );
};

export default ChannelRankInfo;
